// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Gotham-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Gotham-BlackIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Gotham-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Gotham-BoldIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Gotham-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Gotham-BookIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Gotham-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Gotham-LightIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Gotham-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Gotham-MediumIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Gotham-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Gotham-ThinIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Gotham-Ultra.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Gotham-UltraIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Gotham-XLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Gotham-XLightIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Optima-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Optima-BlackItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Optima-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Optima-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Optima-DemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Optima-DemiBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Optima-ExtraBlack.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Optima-ExtraBlackIta.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Optima-Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Optima-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Optima-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Optima-Roman.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('opentype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('opentype');
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('opentype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('opentype');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('opentype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('opentype');
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('opentype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('opentype');
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('opentype');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('opentype');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'Optima';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('opentype');
  font-weight: normal;
  font-style: normal;
}

body {
  margin: 0;
  font-family: 'Optima', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0d6efd14;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Open Sans';
  color:  #333;
}

h1 {
  color: #333;
}

.white-space-nowrap {
  white-space: nowrap;
}

.page-container {
  padding: 2rem 5rem;
  min-height: 100vh;
  color: #f0f0f0;
  box-sizing: border-box;
}

.table-responsive {
  border-radius: 8px;
}

.table tr {
  vertical-align: middle;
}

.btn.btn-custom-primary {
    background-color: #172228;
    border-color: #172228;
    color: #fff;
}

.btn.btn-custom-primary:hover, 
.btn.btn-custom-primary:focus, 
.btn.btn-custom-primary:active {
    background-color: #31414b;
    border-color: #31414b;
    color: #fff;
}

.btn.btn-custom-secondary {
    background-color: #d8b8a1;
    border-color: #d8b8a1;
    color: #000;
}

.btn.btn-custom-secondary:hover, 
.btn.btn-custom-secondary:focus, 
.btn.btn-custom-secondary:active {
    background-color: #e6ccba;
    border-color: #e6ccba;
    color: #000;
}

.bg-primary-custom {
  background-color: #172228;
}

.page-item {  
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(216, 184, 161, 0.25);
}

.page-link {  
  color: #000;
}

.page-link:hover {  
  color: #333
}

.active>.page-link, .page-link.active {
  --bs-pagination-active-bg: #d8b8a1;
  --bs-pagination-active-border-color: #d8b8a1;
  color: #000;
}

.full-width {
  width: 100%;
}

.form-control,
.form-select {
    color: #000;
    border-color: #ddd;
}

.form-control:focus,
.form-select:focus,
.form-check-input:focus {
    color: #000;
    border-color: #31414b;
    box-shadow: 0 0 0 .25rem rgba(23, 34, 40, .50);
}

@media (max-width: 992px) {
  .page-container {
    padding: 2rem 1rem;
  }
}

/* Geral */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.tab-content {
  min-height: 400px; /* Ajuste conforme necessário */
	transition: all 0.3s ease-in-out;
}

.modal-content {
  background: #f0f0f0;
  animation: fadeIn 0.3s ease-in-out;
}

/* Animação */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.form-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  min-width: 150px;
}

.form-group label {
  font-size: 0.85rem;
  margin-bottom: 5px;
  font-weight: bold;
}

textarea {
  resize: none;
  min-height: 50px;
  width: 100%;
}

.ReactModal__Overlay {
  z-index: 1000; 
}

.ReactModal__Content {
  z-index: 2000; 
}

.form-group select {
  width: 100%; 
  height: 35px;
  font-size: 0.85rem; 
  padding: 8px; 
  box-sizing: border-box; 
  border: 1px solid #ccc; 
  border-radius: 4px; 
}

.form-group input:focus,
.form-group select:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.7);
  outline: none;
}

.foto-box input[type='file'] {
  display: none;
}

.table-custom-primary {
  --bs-table-bg: #172228;
  --bs-table-color-state: white;
}

.header-custom-primary {
  background-color: #172228;
  color: #fff;
}

.foto-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.foto-box {
  width: 245px;
  height: 250px;
  border: 2px dashed #ccc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}

.foto-placeholder {
  text-align: center;
  color: #777;
  font-size: 0.9rem;
}

.foto-box:hover .foto-placeholder {
  color: #333;
}

.foto-preview {
  width: 250px;
  height: 250px;
  border-radius: 10px;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  padding: 16px;
}

.photo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  height: 150px;
  cursor: pointer;
  position: relative;
  transition: border-color 0.3s;
}

.photo-item label {
  font-weight: bold;
  color: #555;
}

.photo-item:hover {
  border-color: #007bff;
}

.photo-preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.foto-remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(255, 0, 0, 0.8);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.react-crop {
  max-width: 100%;
  max-height: 300px;
  margin-top: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.foto-remove-btn:hover {
  background-color: rgba(255, 0, 0, 1);
}
 
.photo-preview-container,
.photo-placeholder-container {
    width: 250px; 
    height: 250px; 
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5; 
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); 
    border: 1px dashed #ccc; 
    margin: 0 auto;
}

.photo-placeholder-container {
    font-size: 12px;
    color: #777; 
    text-align: center;
    cursor: pointer;
}

.photo-item img {
  width: 100px; 
  height: 100px;
  object-fit: cover; 
  cursor: pointer; 
  border: 1px solid #ccc; 
  border-radius: 4px;
  margin: 5px;
}

.nav-tabs .nav-link {
  cursor: pointer;
}

.nav-tabs .nav-item.show .nav-link, 
.nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #172228;
}

.nav-link {
  color: #000;
}

.nav-link:focus, .nav-link:hover {
  color: #333;
}

.max-h-400 {
  max-height: 400px;
}

.thead-fixed {
  position: sticky;
  top: 0;
}

.table {
  margin-bottom: 0;
}

.tooltip-inner {
  text-align: left !important; /* Garante que o conteúdo esteja alinhado à esquerda */
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
}

p {
  margin-bottom: 0;
}

.bg-info-custom {
  background-color: #d9ecf6;
}

@media (max-width: 992px) {  
  .pagination {    
    flex-flow: wrap;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .foto-box {
    width: 150px;
  }

  .foto-preview {
    width: 150px;
  }
}

.dashboard-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.dashboard-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
}

.info-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.config-card.active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.config-card.active:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.config-card.active:hover .arrow-icon {
  transform: translateX(3px);
}

.cadastro-card.active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.cadastro-card.active:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.cadastro-card.active:hover .arrow-icon {
  transform: translateX(3px);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.css"],"names":[],"mappings":";;AAEA;EACE,qBAAqB;EACrB,+DAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAuD;EACvD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA0D;EAC1D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAuD;EACvD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA6D;EAC7D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;CACnD,gCAAgC;AACjC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B,EAAE,sDAAsD;EACnF,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Black.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-BlackIta.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Bold.otf') format('opentype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-BoldIta.otf') format('opentype');\n  font-weight: bold;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Book.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-BookIta.otf') format('opentype');\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-LightIta.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-MediumIta.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Thin.otf') format('opentype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-ThinIta.otf') format('opentype');\n  font-weight: 100;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-Ultra.otf') format('opentype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-UltraIta.otf') format('opentype');\n  font-weight: 800;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-XLight.otf') format('opentype');\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gotham';\n  src: url('../fonts/Gotham-XLightIta.otf') format('opentype');\n  font-weight: 200;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-Black.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-BlackItalic.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-Bold.otf') format('opentype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-BoldItalic.otf') format('opentype');\n  font-weight: bold;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-DemiBold.otf') format('opentype');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-DemiBoldItalic.otf') format('opentype');\n  font-weight: 600;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-ExtraBlack.otf') format('opentype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-ExtraBlackIta.otf') format('opentype');\n  font-weight: 800;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-Italic.otf') format('opentype');\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-MediumItalic.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Optima';\n  src: url('../fonts/Optima-Roman.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Optima', -apple-system, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0d6efd14;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Open Sans';\n  color:  #333;\n}\n\nh1 {\n  color: #333;\n}\n\n.white-space-nowrap {\n  white-space: nowrap;\n}\n\n.page-container {\n  padding: 2rem 5rem;\n  min-height: 100vh;\n  color: #f0f0f0;\n  box-sizing: border-box;\n}\n\n.table-responsive {\n  border-radius: 8px;\n}\n\n.table tr {\n  vertical-align: middle;\n}\n\n.btn.btn-custom-primary {\n    background-color: #172228;\n    border-color: #172228;\n    color: #fff;\n}\n\n.btn.btn-custom-primary:hover, \n.btn.btn-custom-primary:focus, \n.btn.btn-custom-primary:active {\n    background-color: #31414b;\n    border-color: #31414b;\n    color: #fff;\n}\n\n.btn.btn-custom-secondary {\n    background-color: #d8b8a1;\n    border-color: #d8b8a1;\n    color: #000;\n}\n\n.btn.btn-custom-secondary:hover, \n.btn.btn-custom-secondary:focus, \n.btn.btn-custom-secondary:active {\n    background-color: #e6ccba;\n    border-color: #e6ccba;\n    color: #000;\n}\n\n.bg-primary-custom {\n  background-color: #172228;\n}\n\n.page-item {  \n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(216, 184, 161, 0.25);\n}\n\n.page-link {  \n  color: #000;\n}\n\n.page-link:hover {  \n  color: #333\n}\n\n.active>.page-link, .page-link.active {\n  --bs-pagination-active-bg: #d8b8a1;\n  --bs-pagination-active-border-color: #d8b8a1;\n  color: #000;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.form-control,\n.form-select {\n    color: #000;\n    border-color: #ddd;\n}\n\n.form-control:focus,\n.form-select:focus,\n.form-check-input:focus {\n    color: #000;\n    border-color: #31414b;\n    box-shadow: 0 0 0 .25rem rgba(23, 34, 40, .50);\n}\n\n@media (max-width: 992px) {\n  .page-container {\n    padding: 2rem 1rem;\n  }\n}\n\n/* Geral */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.tab-content {\n  min-height: 400px; /* Ajuste conforme necessário */\n\ttransition: all 0.3s ease-in-out;\n}\n\n.modal-content {\n  background: #f0f0f0;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Animação */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.form-group {\n  flex: 1 1 calc(50% - 10px);\n  display: flex;\n  flex-direction: column;\n  min-width: 150px;\n}\n\n.form-group label {\n  font-size: 0.85rem;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\ntextarea {\n  resize: none;\n  min-height: 50px;\n  width: 100%;\n}\n\n.ReactModal__Overlay {\n  z-index: 1000; \n}\n\n.ReactModal__Content {\n  z-index: 2000; \n}\n\n.form-group select {\n  width: 100%; \n  height: 35px;\n  font-size: 0.85rem; \n  padding: 8px; \n  box-sizing: border-box; \n  border: 1px solid #ccc; \n  border-radius: 4px; \n}\n\n.form-group input:focus,\n.form-group select:focus,\ntextarea:focus {\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.7);\n  outline: none;\n}\n\n.foto-box input[type='file'] {\n  display: none;\n}\n\n.table-custom-primary {\n  --bs-table-bg: #172228;\n  --bs-table-color-state: white;\n}\n\n.header-custom-primary {\n  background-color: #172228;\n  color: #fff;\n}\n\n.foto-upload-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.foto-box {\n  width: 245px;\n  height: 250px;\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9f9f9;\n  position: relative;\n  cursor: pointer;\n}\n\n.foto-placeholder {\n  text-align: center;\n  color: #777;\n  font-size: 0.9rem;\n}\n\n.foto-box:hover .foto-placeholder {\n  color: #333;\n}\n\n.foto-preview {\n  width: 250px;\n  height: 250px;\n  border-radius: 10px;\n}\n\n.photos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  padding: 16px;\n}\n\n.photo-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  height: 150px;\n  cursor: pointer;\n  position: relative;\n  transition: border-color 0.3s;\n}\n\n.photo-item label {\n  font-weight: bold;\n  color: #555;\n}\n\n.photo-item:hover {\n  border-color: #007bff;\n}\n\n.photo-preview-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.foto-remove-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: rgba(255, 0, 0, 0.8);\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.react-crop {\n  max-width: 100%;\n  max-height: 300px;\n  margin-top: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.foto-remove-btn:hover {\n  background-color: rgba(255, 0, 0, 1);\n}\n \n.photo-preview-container,\n.photo-placeholder-container {\n    width: 250px; \n    height: 250px; \n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f5f5; \n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); \n    border: 1px dashed #ccc; \n    margin: 0 auto;\n}\n\n.photo-placeholder-container {\n    font-size: 12px;\n    color: #777; \n    text-align: center;\n    cursor: pointer;\n}\n\n.photo-item img {\n  width: 100px; \n  height: 100px;\n  object-fit: cover; \n  cursor: pointer; \n  border: 1px solid #ccc; \n  border-radius: 4px;\n  margin: 5px;\n}\n\n.nav-tabs .nav-link {\n  cursor: pointer;\n}\n\n.nav-tabs .nav-item.show .nav-link, \n.nav-tabs .nav-link.active {\n  color: #ffffff;\n  background-color: #172228;\n}\n\n.nav-link {\n  color: #000;\n}\n\n.nav-link:focus, .nav-link:hover {\n  color: #333;\n}\n\n.max-h-400 {\n  max-height: 400px;\n}\n\n.thead-fixed {\n  position: sticky;\n  top: 0;\n}\n\n.table {\n  margin-bottom: 0;\n}\n\n.tooltip-inner {\n  text-align: left !important; /* Garante que o conteúdo esteja alinhado à esquerda */\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #ccc;\n}\n\np {\n  margin-bottom: 0;\n}\n\n.bg-info-custom {\n  background-color: #d9ecf6;\n}\n\n@media (max-width: 992px) {  \n  .pagination {    \n    flex-flow: wrap;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n  .foto-box {\n    width: 150px;\n  }\n\n  .foto-preview {\n    width: 150px;\n  }\n}\n\n.dashboard-card {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n}\n\n.dashboard-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  transform: translateY(-4px);\n}\n\n.info-card {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n}\n\n.config-card.active {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.config-card.active:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.config-card.active:hover .arrow-icon {\n  transform: translateX(3px);\n}\n\n.cadastro-card.active {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.cadastro-card.active:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.cadastro-card.active:hover .arrow-icon {\n  transform: translateX(3px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
